const MergeHistoryRole = Object.freeze({
  target: 'MergeHistory_Role_Target',
  source: 'MergeHistory_Role_Source'
})

const MergeHistoryStrategy = Object.freeze({
  simple_profile: 'MergeHistory_Strategy_SimpleProfile',
  create_new_profile: 'MergeHistory_Strategy_Create_NewProfile',
  use_last_updated_profile: 'MergeHistory_Strategy_Use_LastUpdated_Profile'
})

export { MergeHistoryRole, MergeHistoryStrategy }



// WEBPACK FOOTER //
// ./src/modules/profiles/enum/MergeHistory.js